// Dependencies
require("webstrap/type");
require("grid");
require("element/rich-text");

// Styles
require("./news.scss");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/news/index.js
 ** module id = 112
 ** module chunks = 0 1
 **/